import Chevron from './chevron/Chevron';
import Pinwheel from './pinwheel/Pinwheel';
import Plaid from './plaid/Plaid';
import QuarterSquare from './quarterSquare/QuarterSquare';
import Strips from './strips/Strips';
import StripsAdvanced from './stripsAdvanced/StripsAdvanced';
import WeaveClass from './weave/Weave';
import ZigZag from './zigZag/ZigZag';
import { BoardType } from 'Types';

export const BOARD_CLASSES_BY_TYPE = {
  [BoardType.Chevron]: Chevron,
  [BoardType.Pinwheel]: Pinwheel,
  [BoardType.Plaid]: Plaid,
  [BoardType.QuarterSquare]: QuarterSquare,
  [BoardType.Strips]: Strips,
  [BoardType.StripsAdvanced]: StripsAdvanced,
  [BoardType.Weave]: WeaveClass,
  [BoardType.ZigZag]: ZigZag,
};
